<div class="call-details-card">
  <div class="card-header">
    <h3 class="card-title">Detalles</h3>
  </div>

  <div class="card-content">
    <!-- Pasajeros con radio buttons -->
    <div class="details-section">
      <div class="section-header">
        <label class="section-label">Pasajeros</label>
      </div>
      <div class="passengers-selector">
        <ion-radio-group [(ngModel)]="selectedPassengers" (ionChange)="onPassengerChange($event)">
          <div class="passenger-options">
            <div class="passenger-option" *ngFor="let num of [1,2,3,4,5]">
              <div class="passenger-radio-container" [class.selected]="selectedPassengers === num"
                (click)="selectedPassengers = num">
                <ion-radio mode="md" [value]="num"></ion-radio>
                <label>{{ num }}</label>
              </div>
            </div>
          </div>
        </ion-radio-group>
      </div>
    </div>

    <!-- Extras con toggle -->
    <div class="details-section">
      <div class="toggle-option">
        <ion-toggle [checked]="showExtras" (ionChange)="onExtrasToggle($event)" class="custom-toggle">
        </ion-toggle>
        <label (click)="showExtras = !showExtras; onExtrasToggle({detail: {checked: showExtras}})">Extras</label>
      </div>

      <!-- Detalles de extras (visible cuando está activado) -->
      <div class="extras-details" *ngIf="showExtras">
        <div class="extras-grid">
          <div class="extra-option" *ngFor="let extra of availableExtras">
            <ion-checkbox [checked]="selectedExtras[extra.key]" (ionChange)="onExtraChange(extra.key, $event)">
            </ion-checkbox>
            <label
              (click)="selectedExtras[extra.key] = !selectedExtras[extra.key]; onExtraChange(extra.key, {detail: {checked: selectedExtras[extra.key]}})">{{
              extra.translationKey | translate }}</label>
          </div>
        </div>
      </div>
    </div>

    <!-- Notas con toggle -->
    <div class="details-section">
      <div class="toggle-option">
        <ion-toggle [checked]="showNotes" (ionChange)="onNotesToggle($event)" class="custom-toggle">
        </ion-toggle>
        <label (click)="showNotes = !showNotes; onNotesToggle({detail: {checked: showNotes}})">Notas</label>
      </div>

      <!-- Campo de notas (visible cuando está activado) -->
      <div class="notes-details" *ngIf="showNotes">
        <ion-textarea [(ngModel)]="notes" placeholder="Escribe las notas aquí ..." [autoGrow]="true" [rows]="3"
          class="general">
        </ion-textarea>
      </div>
    </div>

    <!-- Servicio prioritario -->
    <div class="details-section">
      <div class="toggle-option">
        <ion-toggle [checked]="isPriorityService" (ionChange)="onPriorityToggle($event)"
          class="custom-toggle priority-toggle">
        </ion-toggle>
        <label
          (click)="isPriorityService = !isPriorityService; onPriorityToggle({detail: {checked: isPriorityService}})">Servicio
          prioritario</label>
      </div>
    </div>
  </div>
</div>